import React, { useEffect, useState } from 'react'

export const RangeInput = ({ id = 'myRange', min = 1, max = 100, value = 50, step = 1, onChange }) => {

	const [innerValue, setInnerValue] = useState(value)

	useEffect(() => {
		setInnerValue(value)
	}, [value])

	return (
		<input
			type='range'
			className='slider'
			id={id}
			min={min}
			max={max}
			step={step}
			value={innerValue}
			onChange={(e) => {
				setInnerValue(e.currentTarget.value)
				onChange(e.currentTarget.value)
			}}
		/>
	)
}
